/* rebuild-zoom.js — PDP fullscreen photo viewer (owner 2026-06-18).
   Event-delegated so it works even though gallery images lazy-load after init.
   External file (theme lazyload breaks inline scripts). No tracking touched. */
(function(){
  var ov,big,imgs=[],cur=0;
  function galEl(){return document.querySelector('.media-slider .slider-container')||document.querySelector('.product-single__media-group');}
  function srcOf(i){return imgs[i].currentSrc||imgs[i].src||imgs[i].getAttribute('data-src')||'';}
  function build(){
    if(ov)return;
    ov=document.createElement('div');ov.className='rb-zoom-ov';ov.setAttribute('role','dialog');ov.setAttribute('aria-modal','true');
    ov.innerHTML='<button class="rb-zoom-close" aria-label="Kapat">×</button>'+
      '<button class="rb-zoom-nav rb-zoom-prev" aria-label="Önceki">‹</button>'+
      '<img class="rb-zoom-img" alt="">'+
      '<button class="rb-zoom-nav rb-zoom-next" aria-label="Sonraki">›</button>';
    document.body.appendChild(ov);
    big=ov.querySelector('.rb-zoom-img');
    ov.querySelector('.rb-zoom-close').addEventListener('click',close);
    ov.querySelector('.rb-zoom-prev').addEventListener('click',function(e){e.stopPropagation();show(cur-1);});
    ov.querySelector('.rb-zoom-next').addEventListener('click',function(e){e.stopPropagation();show(cur+1);});
    big.addEventListener('click',function(e){e.stopPropagation();big.classList.toggle('is-zoomed');});
    ov.addEventListener('click',function(e){if(e.target===ov)close();});
    var x0=null;ov.addEventListener('touchstart',function(e){x0=e.touches[0].clientX;},{passive:true});
    ov.addEventListener('touchend',function(e){if(x0===null)return;var dx=e.changedTouches[0].clientX-x0;if(Math.abs(dx)>40&&!big.classList.contains('is-zoomed'))show(cur+(dx<0?1:-1));x0=null;});
    document.addEventListener('keydown',function(e){if(!ov.classList.contains('is-open'))return;if(e.key==='Escape')close();else if(e.key==='ArrowLeft')show(cur-1);else if(e.key==='ArrowRight')show(cur+1);});
  }
  function show(i){if(!imgs.length)return;cur=(i+imgs.length)%imgs.length;big.classList.remove('is-zoomed');big.src=srcOf(cur);}
  function close(){if(ov)ov.classList.remove('is-open');document.documentElement.style.overflow='';}
  function openAt(target){
    var g=galEl();imgs=g?[].slice.call(g.querySelectorAll('img')):[];
    if(!imgs.length)return;
    build();var idx=imgs.indexOf(target);show(idx<0?0:idx);
    ov.classList.add('is-open');document.documentElement.style.overflow='hidden';
  }
  function init(){
    var g=galEl();if(!g)return;
    g.style.cursor='zoom-in';
    g.addEventListener('click',function(e){var im=e.target.closest('img');if(im&&g.contains(im)){e.preventDefault();openAt(im);}});
  }
  if(document.readyState!=='loading')init();else document.addEventListener('DOMContentLoaded',init);
})();
